import { toast } from 'sonner';

import { extractErrorMessage } from './axios';
import { requestIdOf } from './request-id';

/** An error toast that carries the request id, so a person can quote it to whoever reads the logs. */
export const toastApiError = (error: unknown): void => {
  const requestId = requestIdOf(error);

  toast.error(
    extractErrorMessage(error),
    requestId ? { description: `Reference: ${requestId}` } : undefined,
  );
};
